<div class="repair">
  <div class="repair-content">
    <div class="repair-content-img">
      <i class="repair-content-img__bg"></i>
    </div>
    <h1>We are sorry for the inconvenience. We are undergoing maintenance and will be back online later.</h1>
  </div>
</div>
